import { create } from "zustand"
import { persist } from "zustand/middleware"

import type { SessionData } from "@productlane/auth"

interface AuthState {
	data: SessionData | null
	setSessionData: (value: SessionData | null) => void
}

export const useAuthState = create<AuthState>()(
	persist(
		(set, get) => ({
			data: null,
			// Every useSession mount sets the cached session again; skipping the
			// no-op spares each subscriber a render and a localStorage write.
			setSessionData: (value) => {
				if (get().data === value) return
				set({ data: value })
			},
		}),
		{ name: "auth-state" },
	),
)
export const useAuthStateData = () => useAuthState((state) => state.data)
